(function($){
	$(document).ready(()=> {
		$('.js-content-block-related-sections').each((index, item)=> {
			$(item).slick({
				infinite: false,
				slidesToShow: 3,
				slidesToScroll: 1,
				arrows: false,
				dots: true,
				dotsClass: 'content-block-related-sections__dots',
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
				]
			})
		});
	});
})(jQuery);
